import MyVue from "@vue/compat";
import Notifications from "@kyvg/vue3-notification";
import Loading from "vue-loading-overlay";
import {
  BootstrapVue,
  BIcon,
  BIconArrowClockwise,
  BIconArrowDown,
  BIconArrowLeft,
  BIconArrowLeftSquare,
  BIconArrowRightSquare,
  BIconArrowUp,
  BIconArrowUpRightSquare,
  BIconBoxArrowRight,
  BIconCaretDownFill,
  BIconCaretRightFill,
  BIconCaretUpFill,
  BIconCheck,
  BIconCheck2,
  BIconCheckCircleFill,
  BIconChevronDown,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconCircleFill,
  BIconClipboard,
  BIconCloudDownloadFill,
  BIconDownload,
  BIconExclamationCircleFill,
  BIconEye,
  BIconEyeSlash,
  BIconFileEarmark,
  BIconFileEarmarkText,
  BIconFiles,
  BIconGeoAltFill,
  BIconInfoCircle,
  BIconInfoCircleFill,
  BIconList,
  BIconPatchCheckFill,
  BIconPencilSquare,
  BIconPinMap,
  BIconPlayCircleFill,
  BIconPlusLg,
  BIconSearch,
  BIconShare,
  BIconToggleOn,
  BIconTrash,
  BIconX,
  BIconXCircle,
  BIconXCircleFill,
  BIconXLg,
} from "bootstrap-vue";
import SideBar from "@/components/SidebarPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import VueNumber from "vue-number-animation";
import "es6-promise/auto";
import GoogleAuth from "../helpers/googleAuth";
import detectBrowser from "vue-detect-browser";
import VueConfetti from "vue-confetti";
import { VueRecaptchaPlugin } from 'vue-recaptcha/head'
import VueTelInput from '@anhoang/vue-tel-input-compat';

//css assets
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/themify-icons.css";
import "@/assets/css/style.css";
import "@/assets/css/mobile.style.css";
import "@/assets/sass/style.scss";
import "@/assets/sass/paper-dashboard.scss";
import "vue-loading-overlay/dist/css/index.css";
import { configure, defineRule } from "vee-validate";
import { confirmed, email, min, regex, required } from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import en from "@vee-validate/i18n/dist/locale/en.json";
import id from "@vee-validate/i18n/dist/locale/id.json";
import 'vue-tel-input/vue-tel-input.css';
import "@/assets/sass/orders-page.scss";
import "@/assets/sass/_custom-modal.scss";
import "@/assets/sass/_custom-scroll.scss";
import "@/assets/sass/_property-card.scss";
import "@/assets/sass/_custom-form.scss";
import "@/assets/sass/_property-card.scss";

const globalOptions = {
  mode: 'auto',
};

export default {
  install(Vue) {
    Vue.component("loading", Loading);
    Vue.use(VueNumber);
    MyVue.use(BootstrapVue);
    // Register only the icons the app actually uses instead of IconsPlugin
    // (~300 icons). <b-icon icon="..."> resolves "BIcon<PascalName>" from this
    // registry and falls back to a blank icon when unregistered — any icon
    // added in a template must also be registered here.
    const usedIcons = {
      BIcon,
      BIconArrowClockwise,
      BIconArrowDown,
      BIconArrowLeft,
      BIconArrowLeftSquare,
      BIconArrowRightSquare,
      BIconArrowUp,
      BIconArrowUpRightSquare,
      BIconBoxArrowRight,
      BIconCaretDownFill,
      BIconCaretRightFill,
      BIconCaretUpFill,
      BIconCheck,
      BIconCheck2,
      BIconCheckCircleFill,
      BIconChevronDown,
      BIconChevronLeft,
      BIconChevronRight,
      BIconChevronUp,
      BIconCircleFill,
      BIconClipboard,
      BIconCloudDownloadFill,
      BIconDownload,
      BIconExclamationCircleFill,
      BIconEye,
      BIconEyeSlash,
      BIconFileEarmark,
      BIconFileEarmarkText,
      BIconFiles,
      BIconGeoAltFill,
      BIconInfoCircle,
      BIconInfoCircleFill,
      BIconList,
      BIconPatchCheckFill,
      BIconPencilSquare,
      BIconPinMap,
      BIconPlayCircleFill,
      BIconPlusLg,
      BIconSearch,
      BIconShare,
      BIconToggleOn,
      BIconTrash,
      BIconX,
      BIconXCircle,
      BIconXCircleFill,
      BIconXLg,
    };
    Object.entries(usedIcons).forEach(([name, component]) => {
      MyVue.component(name, component);
    });
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(detectBrowser);

    Vue.use(GoogleAuth, {
      client_id: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID,
      scope: "profile email",
      prompt: "select_account"
    })
    Vue.use(VueConfetti);
    Vue.use(VueRecaptchaPlugin, {
      v2SiteKey: process.env.VUE_APP_RECAPTCHA_V2_SITE_KEY,
      v3SiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true,
      },
    });
    Vue.use(VueTelInput, globalOptions);
    configure({
      generateMessage: localize({
        en,
        id,
      }),
    });
    // vee-validate rules live in one global registry. Register the shared ones
    // here so a lazy-loaded page never depends on another chunk having run its
    // own defineRule() first. Page-specific rules (legal_name, strong_password_*)
    // stay local to the pages that define them.
    defineRule("required", required);
    defineRule("email", email);
    defineRule("min", min);
    defineRule("regex", regex);
    defineRule("confirmed", confirmed);
  },
};
